module.exports = __webpack_public_path__ + "static/img/shuo2.f342ab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuo2.jpg
// module id = YJHp
// module chunks = 1